<template>
    <div class="filter-container" :class="{ 'hidden': loading }">
        <div :class="`dropdown ${dropdown1Open ? 'open' : ''}`">
            <div :class="`arrow-wrapper up ${dropdown1Open ? '' : 'hidden'}`" @click="toggleFirstDropdown">
                <img class="arrow" src="images/SVG/arrow-up.svg" alt="">
            </div>
            <div :class="`arrow-wrapper down ${dropdown1Open ? 'hidden' : ''}`" @click="toggleFirstDropdown">
                <img class="arrow" src="images/SVG/arrow-down.svg" alt="">
            </div>
            <input id="vrsta-clanka" type="text" name="category" :value="category" @input="setCategory($event.target.value)" readonly placeholder="Vse vsebine">
            <ul id="dropdown-select">
                <hr class="locevalna">
                <li class="status-options"
                    :key="categoryType"
                    v-for="categoryType in categoryTypes"
                    @click="setCategory(categoryType, 0)"
                    v-cloak>
                    {{ categoryType }}
                </li>
            </ul>
        </div>
        <div :class="`dropdown ${dropdown2Open ? 'open' : ''} audience`">
            <div :class="`arrow-wrapper up ${dropdown2Open ? '' : 'hidden'}`" @click="toggleSecondDropdown">
                <img class="arrow" src="images/SVG/arrow-up.svg" alt="">
            </div>
            <div :class="`arrow-wrapper down ${dropdown2Open ? 'hidden' : ''}`" @click="toggleSecondDropdown">
                <img class="arrow" src="images/SVG/arrow-down.svg" alt="">
            </div>
            <input id="izbira-vidnosti" type="text" name="visibility" :value="visibility" @input="setVisibility($event.target.value)" readonly placeholder="Za vse">
            <ul id="dropdown-select" >
                <hr class="locevalna">
                <li class="status-options"
                    v-for="visibilityType in visibilityTypes"
                    :key="visibilityType"
                    @click="setVisibility(visibilityType, 1)"
                    v-cloak>
                    {{ visibilityType }}
                </li>
            </ul>
        </div>
        <blog-filter-legend
            :visibility="visibility"
            :handleVisibility="handleVisibility"
        />
    </div>
</template>


<script>
    import BlogFilterLegend from './BlogFilterLegend.vue';

    export default {
        components: {
            BlogFilterLegend
        },
        props: [
            "category",
            "visibility",
            "categoryTypes",
            "visibilityTypes",
            "handleCategory",
            "handleVisibility",
            "loading"
            ],
		data() {
            return {
                dropdown1Open: false,
                dropdown2Open: false
            }
		},
        mounted() {
            this.filter = "";
        },
        methods: {
            toggleFirstDropdown() {
                this.dropdown1Open = !this.dropdown1Open;
            },
            toggleSecondDropdown() {
                this.dropdown2Open = !this.dropdown2Open;
            },
            setCategory(category, dropdown) {
                if (this.category !== category) {
                    this.handleCategory(category, this.category);
                }
                dropdown ? this.toggleSecondDropdown() : this.toggleFirstDropdown();
			},
            setVisibility(visibility, dropdown) {
                if (this.visibility !== visibility) {
                    this.handleVisibility(visibility, this.visibility);
                }
                dropdown ? this.toggleSecondDropdown() : this.toggleFirstDropdown();
			},
            handleInput(e) {
                this.filter = e.target.value;
                setTimeout(() => {
                    this.changePropFilter();
                }, 500);
            },
            handleClose() {
                this.filter = "";
                this.handleSearch("");
            },
            changePropFilter() {
                this.handleSearch(this.filter);
            }
        }
    }
</script>



